import { render, staticRenderFns } from "./CameraScanner.vue?vue&type=template&id=0275477a&scoped=true&"
import script from "./CameraScanner.vue?vue&type=script&lang=js&"
export * from "./CameraScanner.vue?vue&type=script&lang=js&"
import style0 from "./CameraScanner.vue?vue&type=style&index=0&id=0275477a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0275477a",
  null
  
)

export default component.exports